import styled from '@emotion/styled'

import colorNames from '../../design/color-names'

import tokens from '../../design/tokens'

import { EDITABLEELEMENT_VARIANT_DANGER } from './EditableElement.constants'

export const EditableElementContainer = styled.div`
  outline: none;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: ${tokens.borderRadius.small};

  padding: 8px 8px;

  color: ${colorNames.boulder};
  line-height: 20px;

  cursor: pointer;

  overflow-wrap: anywhere;

  &[contenteditable='true']:empty:not(:focus)::before {
    content: attr(placeholder);
    pointer-events: none;
    color: ${colorNames.geyser};
    display: block; /* For Firefox */
  }

  &:hover {
    background-color: ${colorNames.wildSand};

    ${({ disabled }) => (disabled ? 'cursor: not-allowed;' : '')}
  }

  &:focus,
  &:active {
    background-color: #fff;
    border: 1px solid ${colorNames.bombay};
    cursor: text;
    color: ${colorNames.tundora01};

    ${({ multiline }) =>
      multiline
        ? ''
        : 'height: auto; min-height: 36px; max-height: unset; overflow: initial; text-overflow: initial; white-space: initial;'}
  }

  ${({ variant }) =>
    variant === EDITABLEELEMENT_VARIANT_DANGER
      ? `border: 1px solid ${colorNames.sunsetOrange} !important;`
      : ''}

  ${({ multiline }) =>
    multiline
      ? 'height: auto; min-height: 36px;'
      : 'height: 36px; max-height: 36px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; '}
`
